<template>
  <div>
    <div class="row justify-content-center mt-5 mb-5">
      <div class="col-md-10">
        <form
          class="form-horizontal "
          role="form"
        >
          <h3 class="d-flex justify-content-center">
            Add New Member
          </h3>
          <div class="d-flex justify-content-center">
            <img src="@/assets/images/profile.png" />
          </div>
          <h3 class="d-flex justify-content-center">
            [{{ member.cardid }}] {{ member.firstname }} {{ member.lastname }}
          </h3>

          <hr/>
          <div class="mb-3">
            
            <label
              for="memtype"
              class="mr-4 control-label"
            >Customer Type:</label>
          
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="type"
                id="type_student"
                value="STUDENT"                
                v-model="member.type"
                :v="$v.member.type"
              />
              <label
                class="form-check-label"
                for="type_student"
              >Student</label>
            </div>
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="type"
                id="type_staff"
                value="STAFF"
                v-model="member.type"
                :v="$v.member.type"
              />
              <label
                class="form-check-label"
                for="type_staff"
              >Staff</label>
            </div>
            <div
              class="form-check form-check-inline"
            >
              <input
                class="form-check-input"
                type="radio"
                name="type"
                id="type_public"
                value="PUBLIC"
                v-model="member.type"
                :v="$v.member.type"
              />
              <label
                class="form-check-label"
                for="type_public"
              >Public</label>
            </div>
            <hr/>
          </div>

          <div class="form-group mt-3 ">
            <v-field
              label="Member Card ID*"
              :v="$v.member.cardid"
            >
              <input
                type="text"
                id="cardid"
                placeholder="Member ID"
                class="form-control"
                autofocus
                v-model="member.cardid"
                @blur="$v.member.cardid.$touch()"
              />
            </v-field>
          </div>

          <div class="form-group">
            <v-field
              label="First Name*"
              :v="$v.member.firstname"
            >
              <input
                type="text"
                id="firstname"
                placeholder="First Name"
                class="form-control"
                autofocus
                v-model="member.firstname"
                @blur="$v.member.firstname.$touch()"
              />
            </v-field>
          </div>
          <div class="form-group">
            <v-field
              label="Last Name*"
              :v="$v.member.lastname"
            >
              <input
                type="text"
                id="lastname"
                placeholder="Last Name"
                class="form-control"
                autofocus
                v-model="member.lastname"
                @blur="$v.member.lastname.$touch()"
              />
            </v-field>
          </div>
          <div class="form-group">
            <v-field
              label="Nick Name [Optional]"
              :v="$v.member.nickname"
            >
              <input
                type="text"
                id="nickname"
                placeholder="Nick Name"
                class="form-control"
                autofocus
                v-model="member.nickname"
                @blur="$v.member.nickname.$touch()"
              />
            </v-field>
          </div>
          <div class="form-group">
            <v-field
              label="Email*"
              :v="$v.member.email"
            >
              <input
                type="text"
                id="email"
                placeholder="Email"
                class="form-control"
                autofocus
                v-model="member.email"
                @blur="$v.member.email.$touch()"
              />
            </v-field>
          </div>

          <div class="form-group">
            <v-field
              label="Phone*"
              :v="$v.member.phone"
            >
              <input
                type="text"
                id="phone"
                placeholder="Phone"
                class="form-control"
                autofocus
                v-model="member.phone"
                @blur="$v.member.phone.$touch()"
              />
            </v-field>
          </div>
          <!--
          <div class="form-group">
            <label for="birthDate" class="col-sm-3 control-label"
              >Date of Birth</label
            >
            <div class="">
              <input type="date" id="birthDate" class="form-control" />
            </div>
          </div>
          -->

          <!-- /.form-group -->
          <div class="form-group">
            <div class=" col-sm-offset-3">
              <span class="help-block">*Required fields</span>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-block"
            @click.prevent="createMember"
            :class="{ invalid: $v.$invalid }"
          >
            Create
          </button>
          <transition name="slide-fade">
            <div
              class="alert alert-danger mt-2"
              role="alert"
              v-if="isCreateError"
            >
              Cannot create member! Something Wrong..
            </div>
          </transition>
          <transition name="slide-fade">
            <div
              class="alert alert-danger mt-2"
              role="alert"
              v-if="isCreateDuplicateCardIDError"
            >
              Card ID is already exists..
            </div>
          </transition>
        </form>
        <!-- /form -->
      </div>
    </div>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  between,
  email,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  props: ["passtext"],
  data() {
    return {
      member: {
        cardid: null, //"100354",
        firstname: null, //"Chor",
        lastname: null, //"Chaa",
        email: null, //"aa@aa.com",
        phone: null, //"08451516",
        type:null,
      },
      loading: false,
      isCreateError: false,
      isCreateDuplicateCardIDError: false
    };
  },
  validations: {
    member: {
      cardid: {
        required,
        minLength: minLength(6),
        //maxLength: maxLength(6),
        //numeric
      },
      email: {
        required,
        email
      },
      type:{
        required,
      },
      firstname: {
        required
      },
      lastname: {
        required
      },
      phone: {
        required
      },
      nickname: {}
    }
  },
  methods: {
    async createMember() {
      this.isCreateError = false;
      this.isCreateDuplicateCardIDError = false;

      this.$v.$touch();
      if (this.$v.$invalid) {
        //alert("All fields are not valid");
      } else {
        this.loading = true;
        //this.errors = null;
        let self = this;
        await axios
          .post("/api/members/create", {
            member: this.member
          })
          .then(response => {
            //console.log("len " + response.data.data.length);
            //console.log(response.data);
            //this.isUpdateCompleted = true;

            this.$store.dispatch("setSaleMember", response.data);
            this.$emit("close");
          })
          .catch(function(error) {
            //console.log(error.response.status);
            //console.log(error.response.data.error);
            //if(error.response.data.errors.message =)
            let errormsg = error.response.data.error;
            if (error.response.status == 500) {
              if (errormsg.match("members_cardid_unique")) {
                self.isCreateDuplicateCardIDError = true;
              } else {
                self.isCreateError = true;
              }
            }
          })
          .finally(() => (this.loading = false));
      }
    }
  }
};
</script>
